"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSizes = void 0;
var fontSizes_1 = __importDefault(require("../tokens/fontSizes"));
exports.fontSizes = fontSizes_1.default;
//# sourceMappingURL=fontSizes.js.map